import create from './base'
import {stringify} from 'qs'
import {baseUrl} from '../config'

const http = create()
http.defaults.baseURL = baseUrl + '/api/infotask/v1'


//查询活动列表
const queryActivity = (schoolCode, searchValue, start, limit, startDate, endDate) => {
    return http.get('/query?' + stringify({
        schoolCode, searchValue, start, limit, startDate, endDate
    }))
}
// 保存活动信息
const saveActivity = ( infoList ) => {
    return http.post('/save', stringify(infoList))
}

// 修改活动信息
const updateActivity = ( infoList ) => {
    return http.post('/update', stringify(infoList))
}

const changeStatus = (id, status) => {
    return http.post('/change_status', stringify({
        id, status
    }))
}
//查看详情(编辑)
const getActivity = (id) => {
    return http.get('/get?' + stringify({
        id
    }))
}

//删除单个活动
const delActivity = (id) => {
    return http.post('/delete?' + stringify({
        id
    }))
}

export default {
    queryActivity,
    saveActivity,
    getActivity,
    delActivity,
    changeStatus,
    updateActivity
}
